
<div class="article-container mt-3">
  {#if $loader}
<div class="loader"></div>
{:else}
<div class="tab-content weather-tab-content d-lg-none">
  <Selector> </Selector>
</div>

<div class="tab-content weather-tab-content d-none d-lg-block">
</div>

  <div class="container">
    <Days />
    <div class="tab-content weather-tab-content d-lg-none">
      <Mobile></Mobile>
    </div>
    <div class="tab-content weather-tab-content d-none d-lg-block">
      <div class="tab-pane show active" role="tabpanel">
         <!--lazy-->
        <div
          class="container-16-9 cover-bg"
          data-src="https://img.rtvslo.si/_static/novi/bootstrap/public/img/weather-widget/slovenia-map.png"
          style="background-image: url('https://img.rtvslo.si/_static/novi/bootstrap/public/img/weather-widget/slovenia-map.png')"
          >

          
		  <Slider />
          <Info />
        </div>
      </div>
    </div>
  </div>
  {/if}
</div>




<script lang="ts">
  import { weatherStore } from "../store";
  const { loader, weatherData } = weatherStore;

  import Days from "./Days.svelte";
  import Slider from "./Slider.svelte";
  import Info from "./Info.svelte";
  import Selector from "./Selector.svelte";
  import Mobile from "./MobileView.svelte";
  const el: HTMLElement = document.getElementById("weather-widget");
  import { getWeatherData } from "../api/getWeatherData";
  //import { onMount } from "svelte";
  //console.log("%cVREME_APP_100622_Bx2_MMC2022", "color: white; font-size: 10px; font-weight: bold")
  getWeatherData();



  //let promise = getWeatherData()
  /*
if (station) {	
	startApp(station)  
	setInterval(function () {
		startApp(station)  
	}, 60000 );
			 
}
*/

  /*
function startApp(station) {
		//getCurrentDate.currentDate()		
		getData(station)
		
	}
*/
</script>
